// extracted by mini-css-extract-plugin
module.exports = {"popups-root":"Z6QKu","popupsRoot":"Z6QKu","popups-wrapper":"o-mwB","popupsWrapper":"o-mwB"};